import { useState, forwardRef } from "react";
// @mui
import {
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Stack,
} from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import { ReselectMeetingDialog } from './';
// utils
import Iconify from '../../../components/Iconify';

export default function MeetingAgainDialog({ isOpen, closeDialog, meetingCount, reloadOffer }) {
  const smUp = useResponsive('up', 'sm');
  const [openReselectMeetingDialog, setOpenReselectMeetingDialog] = useState(false);

  const closeAll = () => {
    setOpenReselectMeetingDialog(false);
    closeDialog();
  }

  return (
    <>
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 24, height: 24, color: 'error.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          회사와 {meetingCount ? meetingCount + 1 : 2}차 미팅 진행을 협의하셨나요?
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }} paragraph>
          이전 미팅에서 회사와 미팅을 한번 더 하기로 협의하셨다면<br/>
          미팅 일정을 잡아주세요.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={1} sx={{ width: '100%' }} justifyContent="flex-end">
          <Button
            onClick={closeDialog}
            size="large"
            sx={{ px: 4 }}
            fullWidth={!smUp}
          >
            돌아가기
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpenReselectMeetingDialog(true)}
            size="large"
            sx={{ px: 4 }}
            fullWidth={!smUp}
          >
            미팅 일정잡기
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
    <ReselectMeetingDialog
      meetingCount={meetingCount}
      isOpen={openReselectMeetingDialog}
      closeDialog={closeAll}
      reloadOffer={reloadOffer}
    />
    </>
  )
};
